import { useCallback, useMemo } from 'react';
import useHttp from './useHttp';
import { useAuth } from '../context/authContext';

const useAuthApi = () => {
  const { sendRequest } = useHttp();
  const authCtx = useAuth();

  const searchSwitchIdentityUsers = useCallback(
    async (search, limit = 20) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/auth/switch-identity/users',
          method: 'GET',
          headers: authCtx.getAuthHeaders({ withDevice: true }),
          params: { search, limit },
        });

        return responseData?.users || [];
      } catch (err) {
        console.error('error in useAuthApi searchSwitchIdentityUsers:', err);
        throw err;
      }
    },
    [authCtx, sendRequest]
  );

  const switchIdentity = useCallback(
    async (userId, deviceType = null) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/auth/switch-identity',
          method: 'POST',
          headers: authCtx.getAuthHeaders({ withDevice: true }),
          body: { userId, deviceType },
        });

        return responseData;
      } catch (err) {
        console.error('error in useAuthApi switchIdentity:', err);
        throw err;
      }
    },
    [authCtx, sendRequest]
  );

  const enableWebauthnBreakglass = useCallback(
    async userId => {
      try {
        return await sendRequest({
          url: `/api/v1/auth/webauthn/breakglass/${userId}`,
          method: 'POST',
          headers: authCtx.getAuthHeaders({ withDevice: true }),
          body: {},
        });
      } catch (err) {
        console.error('error in useAuthApi enableWebauthnBreakglass:', err);
        throw err;
      }
    },
    [authCtx, sendRequest]
  );

  return useMemo(() => {
    return {
      searchSwitchIdentityUsers,
      switchIdentity,
      enableWebauthnBreakglass,
    };
  }, [searchSwitchIdentityUsers, switchIdentity, enableWebauthnBreakglass]);
};

export default useAuthApi;

